export { default } from './Button';



// WEBPACK FOOTER //
// ./src/common/Button/index.ts